import { render, staticRenderFns } from "./wenshidu.vue?vue&type=template&id=7dd92f16&scoped=true&"
import script from "./wenshidu.vue?vue&type=script&lang=js&"
export * from "./wenshidu.vue?vue&type=script&lang=js&"
import style0 from "./wenshidu.vue?vue&type=style&index=0&id=7dd92f16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd92f16",
  null
  
)

export default component.exports